"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCard = void 0;
var theme_ui_1 = require("theme-ui");
var ActionCard = function (_a) {
    var children = _a.children, _b = _a.csx, csx = _b === void 0 ? {} : _b, rest = __rest(_a, ["children", "csx"]);
    return (theme_ui_1.jsx(theme_ui_1.Flex, __assign({ sx: __assign({ py: 3, px: 4, flexDirection: "column", border: "1px solid rgba(255, 255, 255, 0.06)", alignItems: "baseline", maxWidth: [null, null, "100%", 700] }, csx) }, rest), children));
};
exports.ActionCard = ActionCard;
